import { extendTheme } from "@chakra-ui/react";

const theme = extendTheme({
  fonts: {
    body: `'Poppins', sans-serif`, // Changing the body font to Poppins
  },
  colors: {
    chakra: {
      bodyText: "#333333", // Custom body text color
      bodyBg: "#ffffff",   // Custom background color
    },
  },
  lineHeights: {
    base: "1.5", // Custom line-height for base
  },
  transition: {
    duration: {
      normal: "0.3s", // Custom transition duration
    },
  },
});

export default theme;
